<template>
    <div style="with:100%">
        <el-row :gutter="12">
            <el-col :span="6">
                <el-card style="height:100px" shadow="hover">
                    <el-row style="margin-top:5px">
                        <el-col :span="10">
                            <div class="demo-basic--circle">
                                <div class>
                                    <el-avatar :size="50" :src="picUrl" fit="fill"></el-avatar>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="14">
                            <strong>{{ currentUser.TrueName }}{{ currentUser.PositionName }},{{
                                    greetings
                            }}</strong>
                            <br />
                            <div class="sub">
                                {{ currentRole.RoleName }}
                                <el-divider direction="vertical"></el-divider>
                                {{ currentUser.FrameName }}
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :span="18">
                <el-card shadow="hover" style="height:100px" class="short-cuts">
                    <el-row style>
                        <el-col :span="3">
                            <el-button type="primary" plain circle icon="el-icon-pie-chart"
                                @click="gotoPage('/Attendance/AttendanceList')"></el-button>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="warning" plain circle icon="el-icon-search"
                                @click="gotoPage('/Flow/Flow')"></el-button>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="danger" plain circle icon="el-icon-position"
                                @click="gotoPage('/KPI/Index')"></el-button>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="success" plain circle icon="el-icon-s-operation"
                                @click="gotoPage('http://kunpeng.ruizhiqi.com')"></el-button>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="primary" plain circle icon="el-icon-data-line"
                                @click="gotoPage('http://pack.kunpeng.ruizhiqi.com/material')"></el-button>
                        </el-col>
                        <el-col :span="3">
                            <el-button type="primary" plain circle icon="el-icon-aim"
                                @click="gotoPage('/Financial/UserList')"></el-button>
                        </el-col>

                        <el-col :span="3">
                            <el-button type="info" plain circle icon="el-icon-bell"
                                @click="gotoPage('http://crm.hnrich.net')"></el-button>
                        </el-col>
                        <!-- <el-col v-if="
                            currentRole.Key == 'admin' || currentRole.Key == 'HRRecruitment'
                        " :span="3">
                            <el-button type="primary" plain circle icon="el-icon-pie-chart"
                                @click="gotoPage('https://tj.hnruizhiqi.com.cn')"></el-button>
                        </el-col> -->
                    </el-row>
                    <el-row style="margin-top:10px">
                        <el-col :span="3">
                            <div>
                                <div class="sub">考勤查询</div>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <div class="sub">办公审批</div>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <div class="sub">绩效考核</div>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <div class="sub">星火平台</div>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <div class="sub">多媒体库</div>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <div class="sub">财务信息</div>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <div class="sub">跨区举报</div>
                            </div>
                        </el-col>
                        <!-- <el-col v-if="
                            currentRole.Key == 'admin' || currentRole.Key == 'HRRecruitment'
                        " :span="3">
                            <div>
                                <div class="sub">人资招聘</div>
                            </div>
                        </el-col> -->
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="12" style="margin-top:20px">
            <el-col :span="8">
                <el-card shadow="hover">
                    <el-row>
                        <el-col :span="20">
                            <el-tag type="danger" style="float:left">任务情况</el-tag>
                        </el-col>
                    </el-row>
                    <el-row :gutter="6" style="margin-top:10px;">
                        <el-col :span="12">
                            <div @click="doneMessage" style="cursor:pointer;" class="subTitle">
                                <span>待办任务</span>
                            </div>
                            <div @click="doneMessage" style="cursor:pointer;" class="MainNum">
                                <span>{{ NoReadModel.NoReadCount }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div @click="doneMessage" style="cursor:pointer;" class="subTitle">
                                <span>本月已办</span>
                            </div>
                            <div @click="doneMessage" style="cursor:pointer;" class="MainNum">
                                <span>{{ NoReadModel.ReadCount }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <div class="bottomcardText">
                                <el-tag>优秀</el-tag>
                                <i style="color:red" class="el-icon-top"></i>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="bottomcardText">
                                <el-tag type>良好</el-tag>
                                <i style="color:red" class="el-icon-top"></i>
                            </div>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <div class="subcardText">
                        <span>莫问收获，但问耕耘</span>
                    </div>
                </el-card>
                <el-card style="margin-top:15px" shadow="hover">
                    <richPieCalendar :value="now"></richPieCalendar>
                </el-card>
            </el-col>
            <el-col :span="16">
                <el-card shadow="hover">
                    <RichCalendar :value="now"></RichCalendar>
                    <!-- <el-carousel height="188px" :interval="4000" type="card">
            <el-carousel-item>
              
            </el-carousel-item>
          </el-carousel> -->
                </el-card>
            </el-col>
        </el-row>
        <!-- <el-card style="margin-top:20px"></el-card> -->
        <!-- <el-card shadow="hover" :style="cardVisibleStyle">
      <el-tabs v-model="currentSalesFrame" type="card" tab-position="bottom">
        <el-tab-pane label="销售业绩完成" name="sales" :disabled="this.salesDiable">
          <el-row>
            <el-col :span="22">
              <el-tag type="danger" style="float:left">{{currentSaleData.frame}}</el-tag>
              <el-tag style="float:left;margin-left:5px">销售</el-tag>
            </el-col>
            <el-col :span="2">
              <div class="tools">
                <el-tooltip :content="currentSaleData.date" placement="bottom" effect="light">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-top:10px">
            <el-col :span="8">
              <div class="subTitle">
                <span>本月任务</span>
              </div>
              <div class="MainNum">
                <span>￥{{currentSaleData.hasConsumptionPlan}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag type>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均任务：{{currentSaleData.hasConsumptionPlanPerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月已完成</span>
              </div>
              <div class="MainNum">
                <span>￥{{currentSaleData.hasConsumption}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均完成：{{currentSaleData.hasConsumptionPerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月当前完成率</span>
              </div>
              <el-row>
                <div class="MainNum">
                  <span>{{currentSaleData.hasConsumptionRate}}%</span>
                </div>
                <el-progress
                  style="margin-top:25px;margin-bottom:6px"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="currentSaleData.hasConsumptionRate"
                ></el-progress>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均进度：{{currentSaleData.hasConsumptionRatePerDay}}%</span>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="总消费完成" name="total" :disabled="this.serviceDiable">
          <el-row>
            <el-col :span="22">
              <el-tag type="danger" style="float:left">{{currentServiceData.frame}}</el-tag>
              <el-tag style="float:left;margin-left:5px">总消费</el-tag>
            </el-col>
            <el-col :span="2">
              <div class="tools">
                <el-tooltip
                  :content="'数据时间:'+currentServiceData.date"
                  placement="bottom"
                  effect="light"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-top:10px">
            <el-col :span="8">
              <div class="subTitle">
                <span>本月任务</span>
              </div>
              <div class="MainNum">
                <span>￥{{currentServiceData.totalTask}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag type>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均任务：{{currentServiceData.totalTaskPerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月已完成</span>
              </div>
              <div class="MainNum">
                <span>￥{{currentServiceData.totalComplete}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均完成：{{currentServiceData.totalCompletePerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月完成率</span>
              </div>
              <el-row>
                <div class="MainNum">
                  <span>{{currentServiceData.totalRate}}%</span>
                </div>
                <el-progress
                  style="margin-top:25px;margin-bottom:6px"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="currentServiceData.totalRate"
                ></el-progress>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均进度：{{currentServiceData.totalRatePerDay}}%</span>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="信息流消费完成" name="xxl" :disabled="this.serviceDiable">
          <el-row>
            <el-col :span="22">
              <el-tag type="danger" style="float:left">{{currentServiceData.frame}}</el-tag>
              <el-tag style="float:left;margin-left:5px">信息流消费</el-tag>
            </el-col>
            <el-col :span="2">
              <div class="tools">
                <el-tooltip
                  :content="'数据时间:'+currentServiceData.date"
                  placement="bottom"
                  effect="light"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-top:10px">
            <el-col :span="8">
              <div class="subTitle">
                <span>本月任务</span>
              </div>
              <div class="MainNum">
                <span>￥{{currentServiceData.xxlTask}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag type>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均任务：{{currentServiceData.xxlComplete}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月已完成</span>
              </div>
              <div class="MainNum">
                <span>￥{{currentServiceData.xxlComplete}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均完成：{{currentServiceData.xxlCompletePerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月完成率</span>
              </div>
              <el-row>
                <div class="MainNum">
                  <span>{{currentServiceData.xxlRate}}%</span>
                </div>
                <el-progress
                  style="margin-top:25px;margin-bottom:6px"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="currentServiceData.xxlRate"
                ></el-progress>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均进度：{{currentServiceData.xxlRatePerDay}}%</span>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-card>-->

        <!-- <el-row style="margin-top:20px" :gutter="12">
      <el-col :span="8">
        <el-card shadow="hover">
          <RichCalendar :value="now"></RichCalendar>
          <el-tabs v-model="activeName">
            <el-tab-pane label="业绩分布" name="first">
              <div style="width:1100px;height:300px" id="first"></div>
            </el-tab-pane>
            <el-tab-pane label="人员分布" name="second">人员分布</el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span>Top Sales</span>
            <i style="float:right" class="el-icon-question"></i>
          </div>
          <div v-for="(item,index) in topSales" :key="index">
            <el-row>
              <el-col :span="3" class="topSales">
                <el-badge :value="index+1" class="mark" />
              </el-col>
              <el-col :span="7" class="topSales">{{item.name}}</el-col>
              <el-col :span="7" class="topSales">{{item.frame}}</el-col>
              <el-col :span="7" class="topSales">{{item.amount}}</el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row> -->
        <!-- <el-drawer
      size="40%"
      title="子部门详细信息"
      :with-header="false"
      :visible.sync="serviceXxlChildrenVisible"
      direction="rtl"
    >
      <div v-for="(item,index) in serviceChildrenData" :key="index">
        <el-card style="margin-top:10px">
          <el-row>
            <el-col :span="22">
              <el-tag type="danger" style="float:left">{{item.frame}}</el-tag>
              <el-tag style="float:left;margin-left:5px">信息流消费</el-tag>
            </el-col>
            <el-col :span="2">
              <div class="tools">
                <el-tooltip :content="'数据时间:'+item.date" placement="bottom" effect="light">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-top:10px">
            <el-col :span="8">
              <div class="subTitle">
                <span>本月任务</span>
              </div>
              <div class="MainServiceNum">
                <span>￥{{item.xxlTask}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag type>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均任务：{{item.xxlComplete}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月已完成</span>
              </div>
              <div class="MainServiceNum">
                <span>￥{{item.xxlComplete}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均完成：{{item.xxlCompletePerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月完成率</span>
              </div>
              <el-row>
                <div class="MainServiceNum">
                  <span>{{item.xxlRate}}%</span>
                </div>
                <el-progress
                  style="margin-top:25px;margin-bottom:6px"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="item.xxlRate"
                ></el-progress>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均进度：{{item.xxlRatePerDay}}%</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-drawer>
    <el-drawer
      size="40%"
      title="子部门详细信息"
      :with-header="false"
      :visible.sync="serviceTotalChildrenVisible"
      direction="rtl"
    >
      <div v-for="(item,index) in serviceChildrenData" :key="index">
        <el-card style="margin-top:10px">
          <el-row>
            <el-col :span="22">
              <el-tag type="danger" style="float:left">{{item.frame}}</el-tag>
              <el-tag style="float:left;margin-left:5px">总消费</el-tag>
            </el-col>
            <el-col :span="2">
              <div class="tools">
                <el-tooltip :content="'数据时间:'+item.date" placement="bottom" effect="light">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-top:10px">
            <el-col :span="8">
              <div class="subTitle">
                <span>本月任务</span>
              </div>
              <div class="MainServiceNum">
                <span>￥{{item.totalTask}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag type>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均任务：{{item.totalComplete}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月已完成</span>
              </div>
              <div class="MainServiceNum">
                <span>￥{{item.totalComplete}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均完成：{{item.totalCompletePerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月完成率</span>
              </div>
              <el-row>
                <div class="MainServiceNum">
                  <span>{{item.totalRate}}%</span>
                </div>
                <el-progress
                  style="margin-top:25px;margin-bottom:6px"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="item.totalRate"
                ></el-progress>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均进度：{{item.totalRatePerDay}}%</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-drawer>
    <el-drawer
      size="40%"
      title="子部门详细信息"
      :with-header="false"
      :visible.sync="salesChildrenVisible"
      direction="rtl"
    >
      <div v-for="(item,index) in salesChildrenData" :key="index">
        <el-card style="margin-top:10px">
          <el-row>
            <el-col :span="22">
              <el-tag type="danger" style="float:left">{{item.frame}}</el-tag>
              <el-tag style="float:left;margin-left:5px">总消费</el-tag>
            </el-col>
            <el-col :span="2">
              <div class="tools">
                <el-tooltip :content="'数据时间:'+item.date" placement="bottom" effect="light">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-top:10px">
            <el-col :span="8">
              <div class="subTitle">
                <span>本月任务</span>
              </div>
              <div class="MainServiceNum">
                <span>￥{{item.hasConsumptionPlan}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag type>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均任务：{{item.hasConsumptionPlanPerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月已完成</span>
              </div>
              <div class="MainServiceNum">
                <span>￥{{item.hasConsumption}}</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>月同比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>12%
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bottomcardText">
                    <el-tag>周环比</el-tag>
                    <i style="color:red" class="el-icon-top"></i>11%
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均完成：{{item.hasConsumptionPerDay}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="subTitle">
                <span>本月完成率</span>
              </div>
              <el-row>
                <div class="MainServiceNum">
                  <span>{{item.hasConsumptionRate}}%</span>
                </div>
                <el-progress
                  style="margin-top:25px;margin-bottom:6px"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="item.hasConsumptionRate"
                ></el-progress>
              </el-row>
              <el-divider></el-divider>
              <div class="subcardText">
                <span>日均进度：{{item.hasConsumptionRatePerDay}}%</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-drawer>-->
    </div>
</template>

<script>
import { Encrypt, Decrypt } from "../until/ZeusApiSDK/Logic/CryptoLogic";
import {
    GetChildrenFrameIdsByParentID,
    GetChildrenFrameIdsByParentIDLevelOne,
    GetCurrentUserRoles,
    GetNoRead
} from "../until/ZeusApiSDK/Logic/HomeLogic";
import {
    GetSalesData,
    GetServiceData,
    GetChildSalesData,
    GetChildServiceData
} from "../until/ZeusApiSDK/Logic/ConsumptionLogic";
import RichCalendar from "../components/richCalendar";
import richPieCalendar from "../components/richPieCalendar";
export default {
    //inject: ['reload'],
    components: {
        RichCalendar,
        richPieCalendar
    },
    data () {
        return {
            now: new Date(),
            picUrl:
                "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            currentUser: {},
            currentRole: {},
            greetings: "",
            activeName: "first",
            topSales: [],
            salesData: [],
            currentSaleData: {},
            salesDiable: false,
            currentSalesFrame: "sales",
            serviceData: [],
            serviceDiable: false,
            currentServiceData: {},
            cardVisibleStyle: {
                "margin-top": "20px"
            },
            Roles: {},
            NoReadModel: {} //当前待办事项信息

            // salesChildrenData: [],
            // salesChildrenVisible: false,
            // serviceChildrenData: [],
            // serviceXxlChildrenVisible: false,
            // serviceTotalChildrenVisible: false
        };
    },
    created () {
        // this.reload();
        // this.reload();
        this.setUserName();
        this.GetCurrentRole();
        this.GetGreetings();
        this.setTopSales();
        this.setConsumeptionData();
        //获取待办事项已读/未读数量
        this.getDonemessage();
    },
    mounted () {
        this.SetCharts();
    },
    methods: {
        setUserName: function () {
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        GetCurrentRole: function () {
            var currentRole = window.sessionStorage.getItem("CurrentUserRole");
            if (!currentRole || currentRole == "undefined") {
                GetCurrentUserRoles(this.currentUser.UserId).then(cur => {
                    window.sessionStorage.setItem(
                        "CurrentUserRoles",
                        Encrypt(JSON.stringify(cur))
                    );
                    this.currentUserRoles = cur;
                    this.Roles = cur;
                    this.currentUserRole = cur[0];
                });
            } else {
                this.currentRole = JSON.parse(
                    Decrypt(window.sessionStorage.getItem("CurrentUserRole"))
                );
            }
        },
        setConsumeptionData: function () {
            GetSalesData("5435", "1").then(res => {
                if (res.length > 0) {
                    this.salesData = res;
                    this.currentSaleData = this.formatSalesData(this.salesData)[0];
                } else {
                    this.salesDiable = true;
                }
                GetServiceData("5435", "1").then(s => {
                    if (s.length > 0) {
                        this.serviceData = s;
                        this.currentServiceData = this.formatServiceData(
                            this.serviceData
                        )[0];
                    } else {
                        this.serviceDiable = true;
                    }
                    if (this.salesDiable && this.serviceDiable) {
                        this.cardVisibleStyle = { display: "none", "margin-top": "20px" };
                    }
                    if (this.salesDiable && !this.serviceDiable) {
                        this.currentSalesFrame = "total";
                    }
                });
            });
        },
        getDonemessage: function () {
            GetNoRead(this.currentUser.UserId).then(res => {
                if (res) {
                    this.NoReadModel = res;
                    if (
                        this.NoReadModel != null &&
                        this.NoReadModel.Title != null &&
                        this.NoReadModel.Title != "" &&
                        this.NoReadModel.Title != "undefined"
                    ) {
                        //数据不为空时，弹出消息提示
                        this.$notify({
                            title: "您有一条新的消息",
                            dangerouslyUseHTMLString: true,
                            message:
                                '<a target="_blank" style="text-decoration:none;color:#303030;" href="' +
                                this.NoReadModel.Url +
                                '">' +
                                this.NoReadModel.Title +
                                "</a>"
                        });
                    }
                } else {
                    this.NoReadModel.NoReadCount = 0;
                    this.NoReadModel.ReadCount = 0;
                }
            });
        },
        doneMessage: function () {
            this.$router.push("/Done/DoneMessage");
        },
        // GetChildrenSales(frameId) {
        //   if (frameId != "5a7eafb2-0b31-46cc-93db-bd97ab0fd1ae") {
        //     GetChildrenFrameIdsByParentID(frameId).then(children => {
        //       if (children) {
        //         GetChildSalesData(children).then(res => {
        //           this.salesChildrenData = res;
        //           this.salesChildrenData = this.formatSalesData(
        //             this.salesChildrenData
        //           );
        //         });
        //       }
        //     });
        //   } else {
        //     GetChildrenFrameIdsByParentIDLevelOne(frameId).then(children => {
        //       if (children) {
        //         GetChildSalesData(children).then(res => {
        //           this.salesChildrenData = res;
        //           this.salesChildrenData = this.formatSalesData(
        //             this.salesChildrenData
        //           );
        //         });
        //       }
        //     });
        //   }
        //   this.salesChildrenVisible=true;
        // },
        // GetChildrenService(frameId, type) {
        //   GetChildrenFrameIdsByParentID(frameId).then(children => {
        //     if (children) {
        //       GetChildServiceData(children).then(res => {
        //         this.serviceChildrenData = res;
        //         this.serviceChildrenData = this.formatServiceData(
        //           this.serviceChildrenData
        //         );
        //         if ((type = "total")) {
        //           this.serviceTotalChildrenVisible = true;
        //         } else {
        //           this.serviceXxlChildrenVisible = true;
        //         }
        //       });
        //     }
        //   });
        // },
        formatSalesData (salesData) {
            var dateCnt = this.getCurrentMonthDayCount();
            var currentDate = new Date().getDate();
            salesData.forEach(element => {
                element.hasConsumptionRate = Number(
                    (element.hasConsumptionRate * 100).toFixed(2)
                );
                element.hasConsumptionPlanPerDay = (
                    element.hasConsumptionPlan / dateCnt
                ).toFixed(2);
                element.hasConsumptionPerDay = (
                    element.hasConsumption / currentDate
                ).toFixed(2);
                element.hasConsumptionRatePerDay = Number(
                    (element.hasConsumptionRate / currentDate).toFixed(2)
                );
                element.hasConsumption = element.hasConsumption.toLocaleString();
                element.hasConsumptionPlan = element.hasConsumptionPlan.toLocaleString();
            });
            return salesData;
        },
        formatServiceData (serviceData) {
            var dateCnt = this.getCurrentMonthDayCount();
            var currentDate = new Date().getDate();
            serviceData.forEach(element => {
                element.totalRate = Number((element.totalRate * 100).toFixed(2));
                element.xxlRate = Number((element.xxlRate * 100).toFixed(2));
                element.totalTaskPerDay = (element.totalTask / dateCnt).toFixed(2);
                element.totalCompletePerDay = (
                    element.totalComplete / currentDate
                ).toFixed(2);
                element.totalRatePerDay = Number(
                    element.totalRate / currentDate
                ).toFixed(2);
                element.xxlTaskPerDay = (element.xxlTask / dateCnt).toFixed(2);
                element.xxlCompletePerDay = (element.xxlComplete / currentDate).toFixed(
                    2
                );
                element.xxlRatePerDay = Number(element.xxlRate / currentDate).toFixed(
                    2
                );
                element.totalTask = element.totalTask.toLocaleString();
                element.xxlTask = element.xxlTask.toLocaleString();
                element.totalComplete = element.totalComplete.toLocaleString();
                element.xxlComplete = element.xxlComplete.toLocaleString();
            });
            return serviceData;
        },
        getCurrentMonthDayCount: function () {
            var date = new Date();
            var currentMonth = date.getMonth() + 1;
            date.setMonth(currentMonth);
            date.setDate(0);
            return date.getDate();
        },
        gotoPage: function (url) {
            if (url.indexOf("http://") > -1) {
                var sp = url.indexOf("?") > -1 ? "&" : "?";
                window.open(url + sp + "token=" + localStorage.getItem("token"));
            } else {
                // url = "/" + url;
                this.$router.push(url);
            }
        },
        GetGreetings: function () {
            var now = new Date();
            var times = now.getHours();
            var when = parseInt(times);
            if (when >= 0 && when < 9) {
                this.greetings = "早上好";
            }
            if (when >= 9 && when < 11) {
                this.greetings = "上午好";
            }
            if (when >= 11 && when < 14) {
                this.greetings = "中午好";
            }
            if (when >= 14 && when < 18) {
                this.greetings = "下午好";
            }
            if (when >= 18 && when < 24) {
                this.greetings = "晚上好";
            }
        },
        setTopSales: function () {
            this.topSales = [
                {
                    name: "杨铠瑄",
                    usercode: "60575",
                    frame: "销售一部",
                    amount: "5787623.00"
                },
                {
                    name: "邹雨芙",
                    usercode: "3293",
                    frame: "销售二部",
                    amount: "5689154.00"
                },
                {
                    name: "贾银",
                    usercode: "51929",
                    frame: "F5",
                    amount: "4578321.00"
                },
                {
                    name: "刘阳",
                    usercode: "3289",
                    frame: "大客户部",
                    amount: "42546545.00"
                },
                {
                    name: "余洋",
                    usercode: "60634",
                    frame: "大客户部",
                    amount: "2568987.00"
                },
                {
                    name: "刘赞",
                    usercode: "6854",
                    frame: "F6",
                    amount: "24855487.00"
                },
                {
                    name: "黄元元",
                    usercode: "60399",
                    frame: "销售一部",
                    amount: "1945487.00"
                },
                {
                    name: "陈祥",
                    usercode: "60384",
                    frame: "大客户部",
                    amount: "1569854.00"
                },
                {
                    name: "吕东",
                    usercode: "60314",
                    frame: "大客户部",
                    amount: "1345458.00"
                },
                {
                    name: "陈康利",
                    usercode: "6566",
                    frame: "K2",
                    amount: "1025544.00"
                }
            ];
        },
        SetCharts: function () {
            // var firstChart = this.$echarts.init(document.getElementById("first"));
            // //var secondChart = this.$echarts.init(document.getElementById("second"));
            // firstChart.setOption({
            //   title: {
            //     text: "业绩分布情况"
            //   },
            //   xAxis: {
            //     type: "category",
            //     data: [
            //       "Mon",
            //       "Tue",
            //       "Wed",
            //       "Thu",
            //       "Fri",
            //       "Sat",
            //       "Sun",
            //       "Mon",
            //       "Tue",
            //       "Wed",
            //       "Thu",
            //       "Fri",
            //       "Sat",
            //       "Sun",
            //       "Mon",
            //       "Tue",
            //       "Wed",
            //       "Thu",
            //       "Fri",
            //       "Sat",
            //       "Sun"
            //     ]
            //   },
            //   yAxis: {
            //     type: "value"
            //   },
            //   series: [
            //     {
            //       color: "#409EFF",
            //       data: [
            //         120,
            //         200,
            //         150,
            //         80,
            //         70,
            //         110,
            //         130,
            //         120,
            //         200,
            //         150,
            //         80,
            //         70,
            //         110,
            //         130,
            //         120,
            //         200,
            //         150,
            //         80,
            //         70,
            //         110,
            //         130
            //       ],
            //       type: "bar"
            //     }
            //   ]
            // });
        }
    }
};
</script>
<style lang="less" scoped>
.sub {
    font-size: 12px;
    color: #8f8d8d;
    /* margin-top: 10px; */
}

.subcardText {
    font-size: 13px;
    color: #8f8d8d;
    text-align: left;
}

.topSales {
    font-size: 12px;
    color: #8f8d8d;
    text-align: left;
    margin-top: 10px;
}

.bottomcardText {
    font-size: 13px;
    margin-top: 15px;
    color: #8f8d8d;
    // text-align: left;
}

.clearfix {
    text-align: left;
    color: #8f8d8d;
    border: none;
}

.el-card__header {
    border: none !important;
    padding-bottom: 0px !important;
}

.MainNum {
    font-size: 30px;
    // text-align: left;
    font: bold;
}

.MainServiceNum {
    font-size: 20px;
    text-align: left;
    font: bold;
}

.subTitle {
    font-size: 14px;
    // text-align: left;
    font: bold;
    color: #8f8d8d;
    margin-bottom: 10px;
}

.el-carousel__container {
    position: relative;
    height: 240px !important;
}

.tools {
    text-align: right;
    float: right;
    color: #8f8d8d;
    font-size: 12px;
    margin-top: 5px;
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
    overflow: auto;
    /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
    display: none;
}

.short-cuts ::v-deep {
    .el-card__body {
        .el-row {
            .el-col-3 {
                width: 14.285714%;
            }
        }
    }

}
</style>
